import { Service } from '@angular/core';
import { AuthTokens } from '../auth/interfaces/auth.interface';
import { AUTH_STORAGE_KEYS } from '../auth/consts/auth.constants';

@Service()
export class TokenService {
  private readonly ACCESS_TOKEN_KEY = AUTH_STORAGE_KEYS.accessToken;
  private readonly REFRESH_TOKEN_KEY = AUTH_STORAGE_KEYS.refreshToken;
  private readonly TEMP_TOKEN_KEY = AUTH_STORAGE_KEYS.tempToken;

  public setTokens(tokens: AuthTokens): void {
    localStorage.setItem(this.ACCESS_TOKEN_KEY, tokens.accessToken);
    localStorage.setItem(this.REFRESH_TOKEN_KEY, tokens.refreshToken);

    if (tokens.tempToken) {
      localStorage.setItem(this.TEMP_TOKEN_KEY, tokens.tempToken);
    } else {
      localStorage.removeItem(this.TEMP_TOKEN_KEY);
    }
  }

  public getAccessToken(): string | null {
    return localStorage.getItem(this.ACCESS_TOKEN_KEY);
  }

  public getRefreshToken(): string | null {
    return localStorage.getItem(this.REFRESH_TOKEN_KEY);
  }

  public getTempToken(): string | null {
    return localStorage.getItem(this.TEMP_TOKEN_KEY);
  }

  public clearTokens(): void {
    localStorage.removeItem(this.ACCESS_TOKEN_KEY);
    localStorage.removeItem(this.REFRESH_TOKEN_KEY);
    localStorage.removeItem(this.TEMP_TOKEN_KEY);
  }

  public hasToken(): boolean {
    return !!this.getAccessToken();
  }
}
